
import { renderToString } from 'preact-render-to-string';
import { MwlIcons } from "../components/MwlIcons";

export const initSlideshow = (lightbox, slideshowConfig) => {
  lightbox.on('uiRegister', () => {
    let isPlaying = false;
    const playIcon = <MwlIcons icon={'play'} />;
    const pauseIcon = <MwlIcons icon={'pause'} />;

    const updateButton = (el) => {
      el.innerHTML = isPlaying ? renderToString(pauseIcon) : renderToString(playIcon);
    };

    lightbox.pswp.ui.registerElement({
      name: 'slideshow-button',
      order: 9,
      isButton: true,
      html: renderToString(playIcon),
      onClick: (event, el) => {
        isPlaying = !isPlaying;
        updateButton(el);
        const eventName = isPlaying ? 'startSlideshow' : 'stopSlideshow';
        const customEvent = new Event(eventName);
        document.dispatchEvent(customEvent);
      },
    });
  });

  let slideshowInterval;

  lightbox.on('bindEvents', () => {
    document.addEventListener('startSlideshow', () => {
      slideshowInterval = setInterval(() => {
        lightbox.pswp.next();
      }, slideshowConfig.slide_duration);
    });

    document.addEventListener('stopSlideshow', () => {
      clearInterval(slideshowInterval);
    });
  });
};